export default {
    methods: {
        transformToCardFriendlyFormat(conn) {
            if (conn.user) {
                this.transferCommonProps(conn, conn.user)

                return conn.user
            } else if (conn.ancillary) {
                //TODO: No User for Ancillary, update when Ancillary is implemented.
                this.transferCommonProps(conn, conn.ancillary)

                if (conn.ancillary.facilityServices) {
                    conn.ancillary.specialities = conn.ancillary.facilityServices.map((fs) => {
                        return { speciality: fs }
                    })
                }
                conn.ancillary.id = conn.target.id
                conn.ancillary.image = {
                    source: conn.target.avatar.source,
                    'thumb-360': conn.target.avatar['thumb-360'],
                }

                return conn.ancillary
            } else if (conn.invite) {
                this.transferCommonProps(conn, conn.invite)

                conn.invite.specialities = []
                conn.invite.locations = []

                return conn.invite
            } else return conn
        },
        transferCommonProps(conn, to) {
            /* Common connection props */
            to.connectionType = conn.connectionType
            to.connectionDirection = conn.connectionDirection

            /* Common target props */
            to.id = conn.target.id
            to.practiceType = conn.target.practiceType
            to.referralsReceivedCount = conn.target.numOfReferrals
            to.connectionCount = conn.target.numOfConnections
            to.target = conn.target
        },
    },
}
